export default __webpack_public_path__ + "static/trackthebat12-5f01302a6d7e3e5604da25056c7bddb1.jpeg";